import { useState } from 'react';
import { useMutation } from '@apollo/client';
import { useNavigate } from 'react-router-dom';
import { SUBMIT_POST } from '../graphql';

export function Submit() {
  const [title, setTitle] = useState('');
  const [url, setUrl] = useState('');
  const [text, setText] = useState('');
  const [submit, { loading, error }] = useMutation(SUBMIT_POST);
  const nav = useNavigate();

  return (
    <div className="card p-6 animate-slide-up">
      <h1 className="text-lg font-semibold mb-1">Submit</h1>
      <p className="text-sm text-mute mb-6">Share a link, or write a self-post with text only.</p>
      <form
        className="space-y-4"
        onSubmit={async (e) => {
          e.preventDefault();
          const input = { title: title.trim(), url: url.trim() || null, text: text.trim() || null };
          const res = await submit({ variables: { input } });
          const id = res.data?.submitPost?.id;
          if (id) nav(`/post/${id}`);
        }}
      >
        <Field label="Title" hint="3+ characters">
          <input className="input" value={title} onChange={(e) => setTitle(e.target.value)} required minLength={3} placeholder="A descriptive title" />
        </Field>
        <Field label="URL" hint="optional">
          <input className="input" value={url} onChange={(e) => setUrl(e.target.value)} type="url" placeholder="https://…" />
        </Field>
        <Field label="Text" hint="optional, leave empty if linking">
          <textarea className="input resize-y" value={text} onChange={(e) => setText(e.target.value)} rows={6} placeholder="Add context, thoughts, or a question." />
        </Field>
        <div className="flex justify-end">
          <button type="submit" disabled={loading} className="btn-primary disabled:opacity-50">{loading ? 'submitting…' : 'submit post'}</button>
        </div>
        {error && <p className="text-red-300 text-sm">{error.message}</p>}
      </form>
    </div>
  );
}

function Field({ label, hint, children }: { label: string; hint?: string; children: React.ReactNode }) {
  return (
    <label className="block">
      <div className="flex items-baseline justify-between mb-1.5">
        <span className="text-sm text-white font-medium">{label}</span>
        {hint && <span className="text-xs text-mute">{hint}</span>}
      </div>
      {children}
    </label>
  );
}
